<template>
    <div class="dashboard-icons-container">
        <BulletinBoard />

        <div class="icon-grid">
            <div class="icon-card" v-if="$canAccess('Reports')" @click="$router.push({ name: 'Reports' })">
                📊
                <span>Reports</span>
            </div>

            <div class="icon-card" v-if="$canAccess('TimeTableIndex')"
                @click="$router.push({ name: 'TimeTableIndex' })">
                🗓️
                <span>Manage Timetable</span>
            </div>

            <div class="icon-card" v-if="$canAccess('AppointmentIndex')"
                @click="$router.push({ name: 'AppointmentIndex' })">
                📅
                <span>Appointments</span>
            </div>

            <div class="icon-card" v-if="$canAccess('AttendanceDashboard')"
                @click="$router.push({ name: 'AttendanceDashboard' })">
                🧾
                <span>Attendance</span>
            </div>

            <div class="icon-card" v-if="$canAccess('StudentAttendance')"
                @click="$router.push({ name: 'StudentAttendance' })">
                ✔️
                <span>Mark Attendance</span>
            </div>
          
            <div class="icon-card"
                @click="$router.push({ name: 'DocumentsIndex' })">
                📁
                <span>Documents</span>
            </div>


            <!-- <div class="icon-card" v-if="$canAccess('DoctorOrders')" @click="$router.push({ name: 'DoctorOrders' })">
                📝
                <span>Doctor Orders</span>
            </div>
            <div class="icon-card" v-if="$canAccess('PhaseDeterminationList')"
                @click="$router.push({ name: 'PhaseDeterminationList' })">
                📝
                <span>Phase Determination Records</span>
            </div> -->


            <!-- 
            <div class="icon-card" @click="logout()">
                🚪
                <span>Logout</span>
            </div> -->
        </div>



        <div class="icon-grid mt-3">
            <div class="icon-card" v-if="$canAccess('CounselorsIndex')" @click="$router.push('/dashboard/counselors')">
                👩‍⚕️
                <span>Counselors</span>
            </div>

            <div class="icon-card" v-if="$canAccess('EmployeeIndex')" @click="$router.push('/dashboard/employees')">
                👨‍💼
                <span>Employees</span>
            </div>

            <div class="icon-card" v-if="$canAccess('FrontDeskIndex')" @click="$router.push('/dashboard/frontdesk')">
                💼
                <span>FrontDesk Accounts</span>
            </div>

            <div class="icon-card" v-if="$canAccess('StudentsIndex')" @click="$router.push('/dashboard/clients')">
                🧑‍🎓
                <span>Clients</span>
            </div>

            <div class="icon-card" v-if="$canAccess('nurses')" @click="$router.push('/dashboard/nurses')">
                🧑‍⚕️
                <span>Nurses</span>
            </div>
            <div class="icon-card" v-if="$canAccess('PractitionerList')"
                @click="$router.push({ name: 'PractitionerList' })">
                🩺
                <span>Practitioners</span>
            </div>

        </div>

        <div class="icon-grid mt-3">
            <div class="icon-card" v-if="$canAccess('DaysIndex')" @click="$router.push('/dashboard/days')">
                📅
                <span>Days</span>
            </div>

            <div class="icon-card" v-if="$canAccess('TimeSlotIndex')" @click="$router.push('/dashboard/time-slots')">
                ⏳
                <span>Time Slots</span>
            </div>

            <div class="icon-card" v-if="$canAccess('GroupsIndex')" @click="$router.push('/dashboard/groups')">
                👥
                <span>Groups</span>
            </div>

            <div class="icon-card" v-if="$canAccess('StudentEdit')" @click="$router.push('/dashboard/agendas')">
                📝
                <span>Agendas</span>
            </div>

            <div class="icon-card" v-if="$canAccess('medication-list')" @click="$router.push('/dashboard/medications')">
                💊
                <span>Medications</span>
            </div>

            <div class="icon-card" v-if="$canAccess('PhaseScheduleList')"
                @click="$router.push('/dashboard/phase-schedules')">
                📆
                <span>Phase Schedules</span>
            </div>
            <div class="icon-card" v-if="$canAccess('reason-list')" @click="$router.push('/dashboard/reasons')">
                📝
                <span>Reasons for Visit</span>
            </div>
        </div>

    </div>
</template>
<script>
// import DashboardStats from "@/components/DashboardStats.vue";
import emitter from '@/eventBus';
import BulletinBoard from '@/components/BulletinBoard.vue';

export default {
    components: {
        BulletinBoard
    },

    data() {
        return {
            user: {
                name: 'User'
            },
            menuState: {
                manageData: false
            }
            ,
            isFullScreen: false
        };
    },
    computed: {
        userRole() {
            return this.$store.state.user.role;
        }
    },
    methods: {
        hasRole(allowedRoles) {
            if (!this.$store.getters.isAuthenticated) {
                return;
            }
            return allowedRoles.includes(this.userRole);
        },

        toggleMenu(menu) {
            this.menuState[menu] = !this.menuState[menu];
        },
        handleToggleFullscreen() {
            this.isFullScreen = this.$store.getters.isFullScreen;
        }
    },
    mounted() {
        if (this.$store.state.user) {
            this.user = this.$store.state.user;
        }
        emitter.on('toggle-fullscreen', this.handleToggleFullscreen);
        this.isFullScreen = this.$store.getters.isFullScreen;
    }
};
</script>

<style>
.dashboard-icons-container {
    padding: 20px;
    text-align: center;
}

.icon-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 15px;
}

.icon-card {
    background-color: #f4f4f4;
    border-radius: 12px;
    padding: 20px 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    max-width: 300px;
    ;
}

.icon-card:hover {
    background-color: #1dbcbc;
    color: white;
}

.icon-card span {
    display: block;
    font-size: 14px;
    font-weight: normal;
    margin-top: 10px;
}
</style>